import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { snake } from '../helpers/converterString';
import AdAudienceModel, {
  AdAudienceCreateUpdatePayload,
} from '../model/AdAudienceModel';

export default class AdAudienceController extends AuthenticatedController {
  static assignAdAudience(facebookPageId: number, audienceId: number) {
    return super.post(APIRoutes.AD_AUDIENCES, { facebookPageId, audienceId });
  }

  static createAdAudience(
    facebookPageId: number,
    adAudience: Partial<AdAudienceCreateUpdatePayload> = {},
  ) {
    return super.post(APIRoutes.AD_AUDIENCES, {
      facebookPageId,
      ...adAudience,
    });
  }

  static updateAdAudienceByRemoteId(
    facebookPageId: number,
    adAudienceRemoteId: number | string,
    adAudience: Partial<AdAudienceModel>,
  ) {
    return super.put(
      APIRoutes.AD_AUDIENCE(adAudienceRemoteId),
      adAudience,
      snake({ facebookPageId }),
    );
  }

  static getAudience(
    facebookPageId: number,
    audienceId: number,
    remoteId: string,
  ) {
    return super.get(
      APIRoutes.AD_AUDIENCE(remoteId),
      snake({ facebookPageId, audienceId }),
    );
  }

  static retrieveAudienceByRemoteId(
    facebookPageId: number,
    adAudienceRemoteId: string | number,
  ) {
    return super.get(
      APIRoutes.AD_AUDIENCE(adAudienceRemoteId),
      snake({ facebookPageId }),
    );
  }

  static syncAudienceByRemoteId(
    facebookPageId: number,
    adAudienceRemoteId: string | number,
  ) {
    return super.post(
      APIRoutes.AD_AUDIENCE_SYNC(adAudienceRemoteId),
      snake({ facebookPageId }),
    );
  }

  static deleteAudienceByRemoteId(
    facebookPageId: number,
    adAudienceRemoteId: string | number,
  ) {
    return super.deleteWithJsonResult(
      APIRoutes.AD_AUDIENCE(adAudienceRemoteId),
      snake({ facebookPageId }),
    );
  }

  static retrieveAudiences(
    facebookPageId: number,
    adAccountRemoteId?: number | string,
  ) {
    return super.get(
      APIRoutes.AD_AUDIENCES,
      snake({ facebookPageId, adAccountRemoteId }),
    );
  }
}
